export default __webpack_public_path__ + "static/media/z.265a23b0.jpg";